__turbopack_context__.v({
  "featureCell": "feature-cell-module__x0EFGW__featureCell",
  "tooltip": "feature-cell-module__x0EFGW__tooltip",
  "unavailable": "feature-cell-module__x0EFGW__unavailable",
});
